import { render, staticRenderFns } from "./DsfExamPage.vue?vue&type=template&id=a90d7154&"
import script from "./DsfExamPage.vue?vue&type=script&lang=js&"
export * from "./DsfExamPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\vsProject\\dsf-product-exam\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a90d7154')) {
      api.createRecord('a90d7154', component.options)
    } else {
      api.reload('a90d7154', component.options)
    }
    module.hot.accept("./DsfExamPage.vue?vue&type=template&id=a90d7154&", function () {
      api.rerender('a90d7154', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/views/DsfExamPage.vue"
export default component.exports